import React from 'react';
import styled from '@emotion/styled';
import { colors, device } from './layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { Button } from './layout/StyledComponents';
import rectangle from '../images/svgs/mask-slant.svg';
import girl from '../images/homepage.jpg';
import { css, cx } from '@emotion/css';

const StyledSlantedPicture = styled.div<Props>`
    display: flex;
    .text-container {
        padding: 0em 1.25em;
    }
    .image-container {
        position: relative;
        .gold-panel {
            position: absolute;
            top: 4em;
            width: 72px;
            z-index: 20;
            left: 9em;
        }
    }

    .unmasked-image {
        margin-top: 0em;
        z-index: 1;
        height: 528px;

        @media ${device.tablet} {
            z-index: 1;
            width: 100vw;
            height: 528px;
        }
        @media ${device.laptop} {
            height: 90vh;
            width: 45vw;
        }
        @media ${device.desktop} {
            height: 90vh;
        }
    }

    .services-image {
        margin: 2em 0em;
        z-index: 1;
        height: 328px;

        @media ${device.tablet} {
            z-index: 1;
            width: 100vw;
            height: 528px;
        }
        @media ${device.laptop} {
            height: 90vh;
            margin: 0em;
            width: 50vw;
        }
        @media ${device.desktop} {
            max-width: 800px;
            height: 80vh;
            margin: 2em 0em;
        }
    }

    .masked-image {
        margin-top: 0em;
        z-index: 1;
        height: 528px;
        mask-size: cover;
        mask-origin: padding-box;
        mask-repeat: no-repeat;
        mask-position: 0% 100%;
        mask-image: url(${rectangle});
        @media ${device.tablet} {
            z-index: 1;
            width: 350px;
            height: 528px;
            mask-origin: padding-box;
            mask-repeat: no-repeat;
            mask-position: 0% 100%;
            mask-image: url(${rectangle});
        }
        @media ${device.laptop} {
            height: 990px;
            width: 609px;
        }
        @media ${device.laptopL} {
            height: 950px;

            width: 707px;
        }
        @media ${device.desktop} {
            height: 1150px;
        }
        @media ${device.desktopL} {
            width: 807px;
        }
    }
    @media ${device.tablet} {
        .image-container {
            margin: 0 auto;
            .gold-panel {
                display: none;
                position: absolute;
                top: 2em;
                left: 14em;
                width: 253px;
            }
            position: relative;
        }
        h3 {
            padding-right: 1em;
        }
        .text-container {
            margin-top: 5em;
            padding: 0em 6em 0em 3em;
        }
        .flex-container {
            display: flex;
            flex-direction: column;
        }
    }
    @media ${device.laptop} {
        .image-container {
            margin: 0 auto;
            .gold-panel {
                display: block;
            }
        }
        h3 {
            margin-bottom: 0.75em;
        }
        .text-container {
            margin-top: 0;
            padding: 0em 2em 0em 2em;

            > h4 {
                margin-top: 0;
            }

            p {
                margin: 1em 0em 2em;
                padding-right: 2.2em;
            }
        }
        .image-container {
            div {
                width: 40vw;
                max-height: 800px;
            }
            .gold-panel {
                position: absolute;
                top: 2em;
                left: 14em;
                width: 253px;
            }
        }
        .flex-container {
            display: flex;
            flex-direction: ${({ reverse }) => (reverse ? 'row' : 'row-reverse')};
            align-items: center;
        }
    }
    @media ${device.desktop} {
        .text-container {
            max-width: 900px;
        }
        .image-container {
            margin: 0 auto;
            div {
                width: 40vw;
                max-height: 1200px;
            }
            .gold-panel {
                display: block;
                top: 7.5em;
            }
        }
        h3 {
            margin-bottom: 0.75em;
        }
    }
`;

interface Props {
    reverse?: boolean;
}

export const SlantedPicture: React.FC<Props> = ({ children, reverse }) => {
    return <StyledSlantedPicture reverse={reverse}>{children}</StyledSlantedPicture>;
};
